import { Fragment } from "@wordpress/element";
import { InnerBlocks } from "@wordpress/block-editor";
import { __ } from "@wordpress/i18n";

const Slide = {
  title: __('Slide'),
  description: __('Slide to use as element in the slider block.'),
  icon: 'format-image',
  parent: [ 'abs/content-slider-block' ],
  attributes: {
    inverseStyling : {
      type: 'boolean',
      default: false,
    }
  },
  supports: {
    customClassName: false,
  },
  edit: ({ className, attributes, props }) => {
    const blockTemplate = [
      [ 'core/image', { align: 'center', url: 'https://placehold.co/480x278'} ],
      [ 'core/heading', { placeholder: __('Title'), level: 3 } ],
      [ 'core/paragraph', { placeholder: __('Content') } ],
    ];

    // Disable image styles
    // Todo: check how to disable image styles

    return (
      <Fragment>
        <div className={ className }>
          <InnerBlocks template={ blockTemplate } />
        </div>
      </Fragment>
    );
  },

  save: ({ attributes }) => {
    return (
      <div>
        <InnerBlocks.Content />
      </div>
    );
  }
};

export default Slide;
